<script setup lang="ts">
    import NavFooter from '@/components/NavFooter.vue';
    import NavMain from '@/components/NavMain.vue';
    import NavUser from '@/components/NavUser.vue';
    import {
        Sidebar,
        SidebarContent,
        SidebarFooter,
        SidebarHeader,
        SidebarMenu,
        SidebarMenuButton,
        SidebarMenuItem,
        SidebarSeparator,
    } from '@/components/ui/sidebar';
    import { type NavItem, type SharedData } from '@/types';
    import { Link, usePage } from '@inertiajs/vue3';
    import AppLogo from './AppLogo.vue';
    import { computed, type ComputedRef } from 'vue';
    import { mainNavItems, secondaryNavItems, footerNavItems } from '@/utils/pages';
    import { useNavPermissions } from '@/composables/useNavPermissions';

    const { filterNavItems } = useNavPermissions();

    const navigation = computed(() => filterNavItems(mainNavItems));
    const secondaryNavigation = computed(() => filterNavItems(secondaryNavItems));
    const footerNavigation = computed(() => filterNavItems(footerNavItems));
</script>

<template>
    <Sidebar collapsible="icon">
        <SidebarHeader>
            <SidebarMenu>
                <SidebarMenuItem>
                    <SidebarMenuButton
                        class="h-20 pt-[24px] pl-[28px]"
                        as-child
                    >
                        <Link :href="route('v2.index')">
                            <AppLogo />
                        </Link>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarHeader>

        <SidebarContent>
            <NavMain :items="navigation" />
            <SidebarSeparator />
            <NavMain :items="secondaryNavigation" />
        </SidebarContent>

        <SidebarFooter>
            <NavFooter :items="footerNavigation" />
            <NavUser />
        </SidebarFooter>
    </Sidebar>
    <slot />
</template>
